import { useRightsDashboard } from '../../api/hooks';
import { BarList, StatCard } from '../../components/DesignSystem';
import { formatNumber } from '../../lib/format';

function tonedValue(value: number | undefined, tone: string) {
  return <span className={`rfp-value--${tone}`}>{formatNumber(value)}</span>;
}

/** Rights dashboard: status stats + media type and territory breakdowns. */
export function RightsDashboardTab() {
  const dashboard = useRightsDashboard();
  const data = dashboard.data;

  if (dashboard.isLoading) {
    return <p className="rfp-loading">Loading rights dashboard…</p>;
  }

  if (dashboard.isError) {
    return (
      <p className="rfp-inline-error" role="alert">
        Could not load the rights dashboard — please retry.
      </p>
    );
  }

  return (
    <>
      <div className="rfp-stat-grid rfp-stat-grid--tight">
        <StatCard label="Total Rights" value={formatNumber(data?.total)} />
        <StatCard label="Active" value={tonedValue(data?.active, 'teal')} />
        <StatCard label="Expiring 60d" value={tonedValue(data?.expiring60d, 'orange')} />
        <StatCard label="Holdback" value={tonedValue(data?.holdback, 'danger')} />
        <StatCard label="Expired" value={tonedValue(data?.expired, 'danger')} />
      </div>

      <div className="rfp-form-grid">
        <section className="rfp-card">
          <div className="rfp-card__head">
            <h2 className="rfp-card__title">Rights by Media Type</h2>
          </div>
          <BarList
            emptyMessage="No rights recorded yet"
            items={(data?.byMediaType ?? []).map((entry) => ({
              label: entry.mediaType,
              value: entry.count,
            }))}
          />
        </section>

        <section className="rfp-card">
          <div className="rfp-card__head">
            <h2 className="rfp-card__title">Top Territories</h2>
          </div>
          <BarList
            emptyMessage="No territories recorded yet"
            items={(data?.topTerritories ?? []).map((entry) => ({
              label: entry.territory,
              value: entry.count,
            }))}
            tone="primary"
          />
        </section>
      </div>
    </>
  );
}
